export default {"src":"/_next/static/media/unreal.291028f5.svg","height":29,"width":148};